import ProductDetails from '../components/ProductDetails';
import ProductGallery from '../components/ProductGallery';
import PaymentTerms from '../helpers/PaymentTerms';

export default class Product {
  constructor(section) {
    this.el = section.el;
    this.data = section.data;
    this.onboarding = this.data.onboarding;
    this.product = this.data.product;
    this.variantInventory = this.data.variantInventory;

    document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + "px");

    this.paymentTerms = new PaymentTerms(this.el);

    this.productGallery = new ProductGallery({
      el: this.el,
      product: this.product,
      settings: this.data,
    });

    if (this.onboarding) { return; }

    this.productDetails = new ProductDetails({
      el: this.el,
      product: this.product,
      variantInventory: this.variantInventory,
      settings: this.data,
      onVariantChange: variant => {
        this.productGallery.updateGalleryImageByVariant(variant);
        this.paymentTerms.update(variant.id);
      },
    });
  }

  unload() {
    if (this.productDetails) {
      this.productDetails.unload();
    }

    if (this.productGallery) {
      this.productGallery.unload();
    }
  }

  onSectionUnload() {
    this.unload();
  }
}
